import { app } from '@/firebase.config';

function Firebase() {
  this.functions = app.functions('europe-west3');

  if (process.env.NODE_ENV === 'development') {
    this.functions.useFunctionsEmulator('http://localhost:5001');
  }
}

/**
 * Add document in database
 */
// Firebase.prototype.add = async function add(ref, data) {
//   try {
//     return await ref.add(data);
//   } catch (error) {
//     return {
//       result: 'error',
//       message: error,
//     };
//   }
// };

/**
 * Call function
 */
Firebase.prototype.call = async function call(name, data) {
  return this.functions.httpsCallable(name)(data);
};

export default Firebase;
